export default __webpack_public_path__ + "static/image-hero-d922490869ec5916be901020cfdff0f4.png";